<template>
  <div class="date-calendar">
    <div
      class="date-calendar-select"
      :class="{ active: show_calendar }"
      @click.stop="show_calendar_fun"
    >
      <div class="date-calendar-left">
        <i class="icon-date"></i
        ><span :class="{ 'gray-text': !selectDate }">{{
          filter_date_text
        }}</span>
      </div>
      <div class="date-calendar-right">
        <i
          :class="show_calendar ? 'icon-arrow-down' : 'icon-arrow-up'"
          @click.stop="show_calendar_fun"
        ></i>
      </div>
      <div class="date-calendar-center">
        <i
          v-if="filter_date_text && selectDate"
          class="el-icon-error"
          @click.stop="init_date"
        ></i>
      </div>
    </div>
    <div class="date-item" v-show="show_calendar">
      <div class="calendar-head">
        <div class="head-left">
          <i class="el-icon-d-arrow-left" @click.stop="prev_year"></i>
          <i class="el-icon-arrow-left" @click.stop="prev_month"></i>
        </div>
        <div class="head-center">{{ filter_date }}</div>
        <div class="head-right">
          <i class="el-icon-arrow-right" @click.stop="next_month"></i>
          <i class="el-icon-d-arrow-right" @click.stop="next_year"></i>
        </div>
      </div>
      <el-calendar v-model="selectDate">
        <template slot="dateCell" slot-scope="{ date, data }" :class="{ 'is-disabled':data.disabled}">
          <span>{{ dealMyDate(data.day, data) }}</span>
          <p :title="data.content" :class="{ 'has-date': data.isShowContent,'is-disabled':data.disabled }" >
            <!--这里原本有动态绑定的class，去掉-->
            {{ data.day.split("-").slice(2).join("") }}
          </p>
        </template>
      </el-calendar>
      <p><span @click.stop="to_today">今天</span></p>
    </div>
  </div>
</template>
<script>
export default {
  name: "miniCalendar",
  props: {
    resDate: {
      default: [],
      type: Array,
    },
  },
  components: {},
  data() {
    return {
      selectDate: "",
      select_date: "",
      is_change_month: false,
      filter_date: "",
      filter_date_text: "请选择日期",
      show_calendar: false,
      is_hide_calendar: true,
      is_first: true,
      cur_date:'',
    };
  },
  created() {},
  mounted() {
    //渲染日程初始化月份
    this.is_first = true;
    // this.selectDate = new Date();
    this.select_date = new Date();
    this.filter_date =
      this.select_date.getFullYear() +
      "年" +
      (this.select_date.getMonth() + 1) +
      "月";
    this.cur_date = new Date();

    // this.filter_date_text = this.select_date.getFullYear()+'-'+ (this.select_date.getMonth()+1)+'-'+this.select_date.getDate();
  },
  methods: {
    change_date(val) {
      let month = val.getMonth() + 1;
      this.is_change_month = true;
      this.$emit("changeMonth", month);
    },
    dealMyDate(v, data) {
      let cur_date = new Date(v);
      Object.assign(data, { isShowContent: false });
      Object.assign(data, { content: "" });
      Object.assign(data, { disabled: cur_date>this.cur_date?true:false });
      let len = this.resDate.length;
      let res = "";
      for (let i = 0; i < len; i++) {
        if (this.resDate[i] == v) {
          res = "";
          Object.assign(data, { isShowContent: true });
          Object.assign(data, { content: this.resDate[i].content });
          break;
        }
      }
      return res;
    },
    prev_year() {
      if (this.selectDate == "") {
        this.selectDate = this.select_date;
      }
      let year = this.selectDate.getFullYear() - 1;
      let month = this.selectDate.getMonth();
      let date = this.selectDate.getDate();
      this.selectDate = new Date(year, month, date);
      this.filter_date = year + "年" + (month + 1) + "月";
      // this.filter_date_text = year+'-'+ month+'-'+date;
      this.is_hide_calendar = false;
      this.is_first = false;
    },
    next_year() {
      if (this.selectDate == "") {
        this.selectDate = this.select_date;
      }
      let year = this.selectDate.getFullYear() + 1;
      let month = this.selectDate.getMonth();
      let date = this.selectDate.getDate();
      this.selectDate = new Date(year, month, date);
      this.filter_date = year + "年" + (month + 1) + "月";
      // this.filter_date_text = year+'-'+ month+'-'+date;
      this.is_hide_calendar = false;
      this.is_first = false;
    },
    prev_month() {
      if (this.selectDate == "") {
        this.selectDate = this.select_date;
      }
      let month =
        this.selectDate.getMonth() == 0 ? 11 : this.selectDate.getMonth() - 1;
      let year =
        month == 11
          ? this.selectDate.getFullYear() - 1
          : this.selectDate.getFullYear();
      let date = this.selectDate.getDate();
      this.selectDate = new Date(year, month, date);
      this.filter_date = year + "年" + (month + 1) + "月";
      // this.filter_date_text = year+'-'+ month+'-'+date;
      this.is_hide_calendar = false;
      this.is_first = false;
    },
    next_month() {
      if (this.selectDate == "") {
        this.selectDate = this.select_date;
      }
      let month =
        this.selectDate.getMonth() == 11 ? 0 : this.selectDate.getMonth() + 1;
      let year =
        month == 0
          ? this.selectDate.getFullYear() + 1
          : this.selectDate.getFullYear();
      let date = this.selectDate.getDate();
      this.selectDate = new Date(year, month, date);
      this.filter_date = year + "年" + (month + 1) + "月";
      // this.filter_date_text = year+'-'+ month+'-'+date;
      this.is_hide_calendar = false;
      this.is_first = false;
    },
    //重置日期
    init_date() {
      this.select_date = this.selectDate;
      this.selectDate = "";
      this.filter_date_text = "请选择日期";
      this.is_first = false;
    },
    //点击今天
    to_today() {
      this.selectDate = new Date();
      this.filter_date =
        this.selectDate.getFullYear() +
        "年" +
        (this.selectDate.getMonth() + 1) +
        "月";
      this.is_first = false;
    },
    //
    show_calendar_fun() {
      this.show_calendar = !this.show_calendar;
      // if(this.is_first){
      //     this.selectDate = new Date();
      // }
    },
  },
  watch: {
    selectDate: {
      handler(val, old) {
        let cur_date = new Date(val);
        if(cur_date>this.cur_date){
          this.filter_date_text='';
          return;
        }
        let date = new Date(val);
        let date1 = new Date(old);
        let yy = date.getFullYear();
        let yy1 = date1.getFullYear();
        let mm =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        let mm1 =
          date1.getMonth() + 1 < 10
            ? "0" + (date1.getMonth() + 1)
            : date1.getMonth() + 1;
        let mm2 = date.getMonth() + 1;
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let d2 = date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate();
        this.filter_date_text = val ? yy + "-" + mm + "-" + d : "请选择日期";
        if (!this.is_hide_calendar) {
          this.is_hide_calendar = true;
          this.$emit("changeMonth", yy + "-" + mm, yy + "-" + mm + "-" + d);
          return;
        }
        this.show_calendar = false;
        this.is_hide_calendar = true;
        // console.log(yy+'-'+mm+'-'+d,444444444)
        //如果新值和旧值所在的月份相同，则不触发方法。
        // console.log((yy+'-'+mm+'-'+d),(yy1+'-'+mm1+'-'+d2) , (!this.show_calendar||!this.is_first),23232323)
        if (
          yy + "-" + mm + "-" + d != yy1 + "-" + mm1 + "-" + d2 ||
          !this.show_calendar ||
          !this.is_first
        ) {
          this.$emit("changeMonth", null, val ? yy + "-" + mm + "-" + d : "");
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.date-calendar {
  position: relative;
}
.date-calendar-select {
  width: 1.8rem;
  height: 0.32rem;
  line-height: 0.32rem;
  padding: 0 0.1rem;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  overflow: hidden;
  background: #fff;
  &.active {
    border-color: #409eff;
  }
  > div {
    display: inline-block;
  }
  i {
    color: #c0c4cc;
  }
}
.date-calendar-left {
  i {
    display: inline-block;
    width: 0.16rem;
    height: 0.3rem;
    margin-right: 0.08rem;
    &.icon-date {
      background: url("~@/assets/images/date_ico.svg") no-repeat center center;
      background-size: contain;
    }
  }
  .gray-text {
    color: #c0c4cc;
  }
  span,
  i {
    vertical-align: middle;
  }
}
.date-calendar-right,
.date-calendar-center {
  float: right;
}
.date-calendar-center {
  font-size: 0.16rem;
}
.date-calendar-right {
  line-height: 0.32rem;
  margin-left: 0.05rem;
  i {
    display: inline-block;
    width: 0.16rem;
    /*height: 0.16rem;*/
    height: 0.3rem;
    &.icon-arrow-up {
      background: url("~@/assets/images/triangle_arrow_gray_up.svg") no-repeat
        center center;
      background-size: contain;
    }
    &.icon-arrow-down {
      background: url("~@/assets/images/triangle_arrow_gray_down.svg") no-repeat
        center center;
      background-size: contain;
    }
  }
}
.calendar-head {
  display: flex;
  width: 100%;
  text-align: center;
  > div {
    display: inline-block;
    i {
      cursor: pointer;
    }
  }
  .head-center {
    flex: 1;
  }
  .head-left {
    text-align: left;
  }
  .head-right {
    text-align: right;
  }
}
.date-item {
  position: absolute;
  top: 0.4rem;
  left: 0;
  width: 3.4rem;
  /*height: 4rem;*/
  padding: 0.1rem 0.1rem 0;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  z-index: 5;
  > p {
    line-height: 0.4rem;
    border-top: 1px solid #e6e5e5;
    text-align: center;
    color: $blueColor;
    span {
      cursor: pointer;
    }
  }
}
/deep/ .el-calendar__header {
  padding: 0px 0px 10px 0px;
}
/deep/ .el-calendar-table .el-calendar-day {
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.24rem;
  /*padding: 0.1rem;*/
  /*padding: 0;*/
  /*height: 40px;*/
}
/deep/ .el-calendar-table td {
  border-bottom: 0px solid #ebeef5;
  border-right: 0px solid #ebeef5;
}
/deep/ .el-calendar-table tr td:first-child {
  border-left: 0px solid #ebeef5;
}
/deep/ .el-calendar-table tr:first-child td {
  border-top: 0px solid #ebeef5;
}
/deep/ .el-calendar__body {
  border-top: 1px solid #ebeef5;
  padding: 5px;
  p {
    text-align: center;
    i {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      background-color: $blueColor;
      border-radius: 50%;
      text-align: center;
    }
  }
}
/deep/.el-calendar__header {
  border-bottom: 0px solid #ebeef5;
  .el-calendar__title {
    display: none;
  }
  .el-calendar__button-group {
    display: none;
    /*margin-left:10%;*/
  }
}
/deep/ .el-input__inner {
  line-height: 28px;
  height: 28px;
  width: 100%;
}
/deep/ .el-date-editor.el-input {
  width: 30%;
  float: left;
  .el-input__icon {
    line-height: 28px;
  }
}
/deep/ .el-input--suffix .el-input__inner {
  padding-right: 0px;
}
/deep/ .el-input__suffix {
  display: none;
}
/deep/.el-calendar-table td.is-selected {
  background-color: #fff;
}
/deep/.el-calendar-table td.is-selected .el-calendar-day {
  background: #027bfe33;
}
/deep/.el-calendar-table td.is-selected p {
}
.has-date {
  border-radius: 50%;
  background: $blueColor;
  color: #fff;
}
.is-disabled{
  color: #C0C4CC;
  /*pointer-events: none;*/
  cursor: not-allowed;
}
div:hover {
  color: #2c3e50;
}
.has-data-date {
}
</style>
